export default {
  roundtrip: {
    roundtripOptions: 'Round trip options'
  }
}
